// extracted by mini-css-extract-plugin
module.exports = {"trusted_brands":"brands_trusted_brands__9uHBv","mobile_spacing":"brands_mobile_spacing__ZuVWW"};